<template>
  <div class="application-config">
    <!-- 微信小程序 -->
    <div class="app-section">
      <div class="section-header">
        <span class="section-title">微信小程序</span>
        <el-button type="primary" size="small" class="add-btn" @click="handleAdd('wechat')"
          >新增
        </el-button>
      </div>
      <div class="section-content">
        <el-form ref="wexin" :rules="rules" label-width="20px" :model="form">
          <el-table :data="form.wechat" border>
            <el-table-column prop="name" label="名称">
              <template slot-scope="scope">
                <el-form-item
                  label=""
                  :prop="'wechat.' + scope.$index + '.name'"
                  :rules="rules.name"
                >
                  <el-input v-model="scope.row.name" placeholder="微信小程序链接" />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="shortUrl" label="链接" v-if="isEdit">
              <template slot-scope="scope">
                <div v-if="scope.row.shortUrl">
                  <a :href="scope.row.shortUrl" style="color: #0a85f8" target="_blank">{{
                    scope.row.shortUrl
                  }}</a>
                  <i
                    class="el-icon-download copy-icon"
                    @click="downLoadUrl(scope.row)"
                    style="margin-left: 5px; cursor: pointer"
                  ></i>
                  <i
                    class="el-icon-document-copy copy-icon"
                    @click="copyUrl(scope.row.shortUrl)"
                    style="margin-left: 5px; cursor: pointer"
                  ></i>
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleDelete('wechat', scope.$index)"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
    </div>

    <!-- 支付宝小程序 -->
    <div class="app-section">
      <div class="section-header">
        <span class="section-title">支付宝小程序</span>
        <el-button type="primary" size="small" class="add-btn" @click="handleAdd('alipay')"
          >新增
        </el-button>
      </div>
      <div class="section-content">
        <el-form ref="alipay" :rules="rules" label-width="20px" :model="form">
          <el-table :data="form.alipay" border>
            <el-table-column prop="name" label="名称">
              <template slot-scope="scope">
                <el-form-item :prop="'alipay.' + scope.$index + '.name'" :rules="rules.name">
                  <el-input v-model="scope.row.name" placeholder="支付宝小程序名称" />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="shortUrl" label="链接" v-if="isEdit">
              <template slot-scope="scope">
                <div v-if="scope.row.shortUrl">
                  <a :href="scope.row.shortUrl" style="color: #0a85f8" target="_blank">{{
                    scope.row.shortUrl
                  }}</a>
                  <i
                    class="el-icon-download copy-icon"
                    @click="downLoadUrl(scope.row)"
                    style="margin-left: 5px; cursor: pointer"
                  ></i>
                  <i
                    class="el-icon-document-copy copy-icon"
                    @click="copyUrl(scope.row.shortUrl)"
                    style="margin-left: 5px; cursor: pointer"
                  ></i>
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleDelete('alipay', scope.$index)"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
    </div>

    <!-- 抖音小程序 -->
    <div class="app-section" v-if="false">
      <div class="section-header">
        <span class="section-title">抖音小程序</span>
        <el-button type="primary" size="small" class="add-btn" @click="handleAdd('douyin')"
          >新增
        </el-button>
      </div>
      <div class="section-content">
        <el-form ref="douyin" :rules="rules" label-width="20px" :model="form">
          <el-table :data="form.douyin" border>
            <el-table-column prop="name" label="名称">
              <template slot-scope="scope">
                <el-form-item :prop="'douyin.' + scope.$index + '.name'" :rules="rules.name">
                  <el-input v-model="scope.row.name" placeholder="抖音小程序名称" />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="shortUrl" label="链接" v-if="isEdit">
              <template slot-scope="scope">
                <div v-if="scope.row.shortUrl">
                  <a :href="scope.row.shortUrl" style="color: #0a85f8" target="_blank">{{
                    scope.row.shortUrl
                  }}</a>
                  <i
                    class="el-icon-download copy-icon"
                    @click="downLoadUrl(scope.row)"
                    style="margin-left: 5px; cursor: pointer"
                  ></i>
                  <i
                    class="el-icon-document-copy copy-icon"
                    @click="copyUrl(scope.row.shortUrl)"
                    style="margin-left: 5px; cursor: pointer"
                  ></i>
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleDelete('douyin', scope.$index)"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
    </div>

    <!-- 乘客端APP -->
    <div class="app-section" v-if="false">
      <div class="section-header">
        <span class="section-title">乘客端APP</span>
        <el-button type="primary" size="small" class="add-btn" @click="handleAdd('app')"
          >新增
        </el-button>
      </div>
      <div class="section-content">
        <el-form ref="app" :rules="rules" label-width="20px" :model="form">
          <el-table :data="form.app" border>
            <el-table-column prop="name" label="名称">
              <template slot-scope="scope">
                <el-form-item :prop="'app.' + scope.$index + '.name'" :rules="rules.name">
                  <el-input v-model="scope.row.name" placeholder="APP名称" />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="shortUrl" label="链接" v-if="isEdit">
              <template slot-scope="scope">
                <div v-if="scope.row.shortUrl">
                  <a :href="scope.row.shortUrl" style="color: #0a85f8" target="_blank">{{
                    scope.row.shortUrl
                  }}</a>
                  <i
                    class="el-icon-download copy-icon"
                    @click="downLoadUrl(scope.row)"
                    style="margin-left: 5px; cursor: pointer"
                  ></i>
                  <i
                    class="el-icon-document-copy copy-icon"
                    @click="copyUrl(scope.row.shortUrl)"
                    style="margin-left: 5px; cursor: pointer"
                  ></i>
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleDelete('app', scope.$index)"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
    </div>
    <qr-load v-model="qrVisible" :qrCodeUrl="qrCodeUrl" />
  </div>
</template>

<script>
  import qrLoad from './QrLoad.vue'
  import { Message } from 'element-ui'

  const validateName = (rule, value, callback) => {
    console.log(value)
    if (!value) {
      return callback(new Error('请输入应用名称'))
    }
    if (value.length > 30) {
      return callback(new Error('应用名称不能超过30个字符'))
    }
    callback()
  }
  export default {
    name: 'ApplicationConfig',
    components: { qrLoad },
    props: {
      value: {
        type: Object,
        default: () => ({
          wechat: [],
          alipay: [],
          douyin: [],
          app: []
        })
      },
      limits: {
        type: Object,
        default: () => ({
          wechat: -1, // -1 表示不限制
          alipay: -1,
          douyin: -1,
          app: -1
        })
      },
      isEdit: {
        type: Boolean,
        default: false
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data() {
      return {
        rules: {
          name: [{ required: true, validator: validateName, trigger: 'blur' }]
        },
        qrVisible: false,
        qrCodeUrl: ''
      }
    },
    computed: {
      form: {
        get() {
          return this.value
        },
        set(newVal) {
          this.$emit('change', newVal)
        }
      }
    },
    methods: {
      // 添加一个新的应用配置
      handleAdd(type) {
        const listMap = {
          wechat: this.form.wechat,
          alipay: this.form.alipay,
          douyin: this.form.douyin,
          app: this.form.app
        }

        const list = listMap[type]
        const limit = this.limits[type]

        // 检查是否超过限制
        if (limit !== -1 && list.length >= limit) {
          this.$message.warning(`最多只能添加${limit}个配置`)
          return
        }

        const map = new Map([
          ['wechat', '微信小程序'],
          ['alipay', '支付宝小程序'],
          ['douyin', '抖音小程序'],
          ['app', '乘客端app']
        ])

        // 添加新配置
        list.push({
          name: `${map.get(type)}链接${(list.length || 0) + 1}`
        })
      },

      // 删除应用配置
      handleDelete(type, index) {
        const listMap = {
          wechat: this.form.wechat,
          alipay: this.form.alipay,
          douyin: this.form.douyin,
          app: this.form.app
        }

        listMap[type].splice(index, 1)
      },

      // 判断是否有数据
      hasData() {
        return (
          this.form.wechat.length > 0 ||
          this.form.alipay.length > 0 ||
          this.form.douyin.length > 0 ||
          this.form.app.length > 0
        )
      },

      // 验证表单
      validate() {
        return new Promise((resolve, reject) => {
          const promises = this.validateForm()
          // 所有表单验证通过才算通过
          Promise.all(promises).then((results) => {
            const isValid = results.every((valid) => valid)
            if (isValid) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
        })
      },

      validateForm() {
        const formRefs = ['wexin', 'alipay', 'douyin', 'app']
        const promises = []

        // 收集所有表单的验证结果
        formRefs.forEach((ref) => {
          if (this.$refs[ref]) {
            promises.push(
              new Promise((resolve) => {
                this.$refs[ref].validate((valid) => {
                  resolve(valid)
                })
              })
            )
          }
        })

        return promises
      },

      downLoadUrl(row) {
        this.qrVisible = true
        this.qrCodeUrl = row.shortUrl
      },

      copyUrl(url) {
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(url)
            .then(() => {
              Message({
                message: '链接已复制到剪贴板',
                type: 'success'
              })
            })
            .catch(() => {
              Message({
                message: '复制失败，请手动复制',
                type: 'error'
              })
            })
        } else {
          // 兼容不支持clipboard API的浏览器
          const textarea = document.createElement('textarea')
          textarea.value = url
          document.body.appendChild(textarea)
          textarea.select()
          try {
            document.execCommand('copy')
            Message({
              message: '链接已复制到剪贴板',
              type: 'success'
            })
          } catch (err) {
            Message({
              message: '复制失败，请手动复制',
              type: 'error'
            })
          }
          document.body.removeChild(textarea)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .application-config {
    padding: 10px 0;

    .app-section {
      margin-bottom: 10px;

      .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        .section-title {
          font-size: 16px;
          font-weight: 500;
        }
      }

      .section-content {
        .link-input {
          display: flex;
          align-items: center;

          .copy-btn,
          .qrcode-btn {
            margin-left: 5px;
            cursor: pointer;
            color: #409eff;
          }
        }
      }
    }
  }
</style>
